import { SelectedBuilding } from '../building/types';

export const SuiteConstants = {
  ClearSuiteData: 'SUITE_CONSTANTS.CLEAR_SUITE_DATA',
  FormattedSuiteList: 'SUITE_CONSTANTS.FORMATTED_SUITE_LIST',
  SetSelectedBuilding: 'SUITE_CONSTANTS.SELECTED_BUILDING',
  ReceiveSuiteData: 'SUITE_CONSTANTS.RECEIVE_SUITE_DATA',
  ReceiveSuiteDataPoints: 'SUITE_CONSTANTS.RECEIVE_SUITE_DATA_POINTS',
  ReceiveSuiteDetails: 'SUITE_CONSTANTS.RECEIVE_SUITE_DETAILS',
  ReceiveSuiteList: 'SUITE_CONSTANTS.RECEIVE_SUITE_LIST',
  RequestSuiteDetails: 'SUITE_CONSTANTS.REQUEST_SUITE_DETAILS',
  SetSelectedSuite: 'SUITE_CONSTANTS.SET_SELECTED_SUITE',
  SuiteError: 'SUITE_CONSTANTS.SUITE_ERROR',
  ClearError: 'SUITE_CONSTANTS.CLEAR_ERROR',
  UpdateGraphDateRange: 'SUITE_CONSTANTS.UPDATE_GRAPH_DATE_RANGE',
  UpdateLineColorsObj: 'SUITE_CONSTANTS.UPDATE_LINE_COLOR_OBJ',
  UpdateAvailableColors: 'SUITE_CONSTANTS.UPDATE_AVAILABLE_COLORS',
  UpdateSelectedPointsList: 'SUITE_CONSTANTS.UPDATE_SELECTED_POINTS_LIST',
  StartLoading: 'SUITE_CONSTANTS.START_LOADING',
  FinishLoading: 'SUITE_CONSTANTS.FINISH_LOADING',
};

export interface Suite {
  display_name: string;
  uid_hash: string;
}

interface SuiteDetails {
  ambient_temperature: string;
  building_section: string;
  building_slug: string;
  connection_state: string;
  connection_timestamp: string;
  direction: string;
  disconnection_timestamp: string;
  display_name: string;
  fan_mode: string;
  floor_number: number;
  is_fan_running: boolean;
  is_occupied: boolean;
  mode: string;
  serial_number: string;
  state: string;
  status_update_timestamp: string;
  target_temperature: string;
  target_temperature_high: string;
  target_temperature_low: string;
  temperature_satisfaction: string;
  temperature_unit: string;
  thermostat_type: string;
  uid_hash: string;
  unit_number: string;
}

interface Label {
  value: string;
  label: string;
}

export interface GraphDateRange {
  value: string;
  label: string;
  startDatetime?: string;
  endDatetime?: string;
}

interface DataSet {
  id: string;
  name: string;
  unit: string;
  graph_data: Array<Point>;
}

interface Point {
  x: string;
  actual: number;
}

export interface SuiteData {
  date: string;
  point_data: Array<DataSet>;
  report_unit: string;
}

interface DataPoint {
  status: string;
  id: string;
  api_location: string;
  name: string;
}

interface SuiteLineColours {
  ambient_temperature?: string;
  aux_heat_stage_one_runtime?: string;
  aux_heat_stage_three_runtime?: string;
  aux_heat_stage_two_runtime?: string;
  cool_stage_one_runtime?: string;
  cool_stage_two_runtime?: string;
  economizer_runtime?: string;
  fan_runtime?: string;
  heat_stage_one_runtime?: string;
  heat_stage_two_runtime?: string;
  humidity?: string;
  outdoor_humidity?: string;
  outdoor_temperature?: string;
  target_temperature?: string;
  temperature_satisfaction?: string;
  ventilator_runtime?: string;
}

export interface SuiteReducer {
  allSuites: Array<Suite>;
  formattedSuiteList: Array<Label>;
  graphDateRange: GraphDateRange;
  selectedSuite: Label;
  selectedBuilding: SelectedBuilding;
  suiteData: SuiteData;
  allSuiteDataPoints: Array<DataPoint>;
  selectedSuiteDataPoints: Array<DataPoint>;
  suiteDetails: SuiteDetails;
  error?: string;
  isFetching: boolean;
  suiteLineColors: SuiteLineColours;
  availableSuiteLineColors: Array<String>;
}
